import { ChevronDownIcon } from "@/domains/icons"
import { cn } from "@/domains/library"
import { TokenStore } from "@/domains/tokens"
import { TokenIcon } from "@/domains/tokens/components/token-icon"

export const TokenSelectable = ({
  size = 24,
  token,
  setIsOpen,
}: {
  size: number
  token: TokenStore | null
  setIsOpen: (isOpen: boolean) => void
}) => {
  if (!token) return null
  return (
    <div
      className={cn(
        "text-t200 flex flex-none cursor-pointer flex-row items-center rounded-lg rounded-l-none py-2",
        // "hover:bg-p400/50",
      )}
      onClick={() => setIsOpen(true)}
    >
      <TokenIcon token={token} size={size} />
      <div className="ml-[6px] mr-[2px] text-md font-medium ">{token.symbol}</div>
      <ChevronDownIcon className="h-4 w-4" />
    </div>
  )
}
